import React, { useRef, useState } from 'react';
import { Tooltip } from 'antd';

/** Whether an element cuts its text: an ellipsis cuts across, a line clamp down. */
export function overflows(el) {
	return !!el && (el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1);
}

/**
 * Text its CSS may cut (an ellipsis or a line clamp), with the whole of it in
 * a tooltip on hover. The tooltip is measured as it opens, so text that fits
 * shows none, and it says what the element holds, parts of a line that are
 * nodes included. `as` is the element; everything else passes through to it.
 */
export default function OverflowText({ as: Tag = 'div', children, ...rest }) {
	const ref = useRef(null);
	const [open, setOpen] = useState(false);
	return (
		<Tooltip
			// A function, never an empty title: antd reports no hover on a tooltip that has none.
			title={() => ref.current?.textContent}
			open={open}
			onOpenChange={next => setOpen(next && overflows(ref.current))}
			overlayClassName="overflow-text__tip"
		>
			<Tag ref={ref} {...rest}>{children}</Tag>
		</Tooltip>
	);
}
